import gsap from 'gsap';
import { isThereСlass, initMagnetBtn, initSplitText, playSplitText, initFades, playFade, showMagnetBtn, calcContainerMargin } from './common/help_functions';

import { cursorAnimation } from './common/cursor';

import { header } from './common/header';
import {initHomeHeroSection, initScrollMoreButton} from './templates/home_hero';
import { initMissionSection } from './templates/mission';
import { initInsightsSection } from './templates/insights';
import { initSplitSlider } from './templates/split_slider';
import { animateContactsHero, animateContactsMessage } from './templates/contacts';
import {animateHeroTitle, animateHeroDescription, animateButton, initScrollAnchorButton} from './templates/hero-type-1';
import { initInfoSection } from './templates/info_type_1';
import { initInfoSection2 } from './templates/info_type_2';
import { initQuoteSection } from "./templates/section_quote";
import { initTitleSection } from "./templates/section_simple_title";
import { initTitlePortfolio } from "./templates/section_portfolio_of_companies";
import { initFilterPostsSection } from "./templates/section_filter_posts";
import { initCircle } from "./templates/single_team";
import { initMissionSectionType1 } from "./templates/section_mission_type_1";
import { initColumnsInfo } from "./templates/section_columns_info";
import { initCriteriaSection } from "./templates/section_criteria_slider";
import { initBannerSection } from "./templates/section_banner_info";
import { faqSection } from "./templates/section_faq";
import { initSlider } from "./templates/section_slider_type_1";
import {initInfoBlocksSection} from "./templates/section_info_blocks_type_1";
import {initInfo} from "./templates/section_info";
import {initSingleInsights} from "./templates/single-insights";
import {initSearchBtn} from "./templates/search";

require("../sass/style.scss");
require('./vendor/bootstrap-transition.js');
require('./vendor/bootstrap-modal.js');

if ($('.section-faq').length > 0) {
  require('./vendor/bootstrap-collapse.js');
  require('./vendor/isotope.min.js');
}

document.addEventListener('DOMContentLoaded', () => {
  calcContainerMargin();
  header();
  cursorAnimation();
});

window.addEventListener('resize', calcContainerMargin);
window.onpageshow = calcContainerMargin;


window.addEventListener("load", () => {

  initSplitText('.split');
  initFades('.fade');

  gsap.to('body', {
    opacity: 1,
    duration: 2
  });

  (isThereСlass('.btn-magnet')) ? initMagnetBtn() : '';
  (isThereСlass('.hero-section')) ? initHomeHeroSection() : '';
  (isThereСlass('.hero-section')) ? initScrollMoreButton() : '';
  (isThereСlass('.mission-section')) ? initMissionSection() : '';
  (isThereСlass('.mission-type-1-section')) ? initMissionSectionType1() : '';
  (isThereСlass('.insights-section')) ? initInsightsSection() : '';
  (isThereСlass('.split-slider-section')) ? initSplitSlider() : '';
  (isThereСlass('.contacts-hero-section')) ? animateContactsHero() : '';
  (isThereСlass('.message-section')) ? animateContactsMessage() : '';
  (isThereСlass('.hero-type-1-section')) ? animateHeroTitle() : '';
  (isThereСlass('.hero-type-1-section')) ? animateHeroDescription() : '';
  (isThereСlass('.hero-type-1-section')) ? animateButton() : '';
  (isThereСlass('.hero-type-1-section')) ? initScrollAnchorButton() : '';
  (isThereСlass('.info-type-1-section')) ? initInfoSection() : '';
  (isThereСlass('.info-type-2-section')) ? initInfoSection2() : '';
  (isThereСlass('.quote-section')) ? initQuoteSection() : '';
  (isThereСlass('.simple-title-section')) ? initTitleSection() : '';
  (isThereСlass('.portfolio-of-companies-section')) ? initTitlePortfolio() : '';
  (isThereСlass('.section-filter-posts')) ? initFilterPostsSection() : '';
  (isThereСlass('.hero-team')) ? initCircle() : '';
  (isThereСlass('.columns-info-section')) ? initColumnsInfo() : '';
  (isThereСlass('.criteria-slider-section')) ? initCriteriaSection() : '';
  (isThereСlass('.banner-info-section.left-clip-path')) ? initBannerSection() : '';
  (isThereСlass('.banner-info-section.right-clip-path')) ? initBannerSection() : '';
  (isThereСlass('.section-faq')) ? faqSection() : '';
  (isThereСlass('.slider-type-1')) ? initSlider() : '';
  (isThereСlass('.info-blocks-type-1-section')) ? initInfoBlocksSection() : '';
  (isThereСlass('.info-section')) ? initInfo() : '';
  (isThereСlass('.two-column-content-widgets-wrap')) ? initSingleInsights() : '';
  (isThereСlass('#search-modal')) ? initSearchBtn() : '';
});
